import React from "react";

import IconBase, { IconBaseProps } from "./IconBase";

/**
 * Liver — 20×20 lab group icon (Figma 834:54).
 * Single vector layer 15×15 centered inside 20×20 frame (inset 12.5%).
 */
const IconLiver: React.FC<IconBaseProps> = ({
  size = 24,
  color = "currentColor",
  className = "",
  ...props
}) => {
  const iconSize =
    typeof size === "number" ? size : parseInt(size as string, 10) || 24;
  return (
    <IconBase
      size={iconSize}
      color={color}
      className={className}
      viewBox="0 0 20 20"
      {...props}
    >
      <g transform="translate(2.5 2.5)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7416 0.314067C13.0934 0.131321 13.4346 0 13.7285 0C14.0732 0 14.3919 0.103979 14.6399 0.344879C14.8944 0.592063 15 0.919383 15 1.27155C15 1.96121 14.9031 2.64321 14.71 3.31654C14.5198 3.97992 14.2781 4.56758 13.9812 5.07512C13.6942 5.56587 13.384 6.00733 13.0499 6.39787C12.72 6.78362 12.3978 7.09229 12.0825 7.31096C11.7894 7.51417 11.4739 7.67242 11.1638 7.67242C10.814 7.67242 10.4733 7.51083 10.1558 7.27767C9.83154 7.03958 9.52583 6.72612 9.23621 6.34629C8.92992 5.94458 8.68196 5.44429 8.48467 4.85721C8.28287 4.25654 8.18246 3.63054 8.18246 2.98133C8.18246 2.83396 8.18692 2.70554 8.19867 2.60537C8.21512 2.46575 8.26471 2.33113 8.32662 2.20725C8.43537 1.98979 8.62337 1.857 8.83229 1.78987C9.01458 1.73129 9.22746 1.70975 9.45404 1.70975C9.77296 1.70975 10.1419 1.63538 10.5655 1.47088C11.0045 1.30037 11.378 1.11586 11.6893 0.919267C12.0373 0.699521 12.388 0.49775 12.7416 0.314067ZM2.55888 3.67617C3.34321 3.25979 4.19883 3.05317 5.11854 3.05317C5.31633 3.05317 5.4745 3.05537 5.59004 3.06021C5.70217 3.06487 5.85988 3.07404 6.06125 3.08746C6.27571 3.10179 6.47017 3.12921 6.63025 3.17846C6.76937 3.22125 6.9115 3.27854 7.05621 3.34838C7.24329 3.43871 7.4065 3.57062 7.51817 3.75408C7.62467 3.92904 7.67242 4.12371 7.67242 4.32471C7.67242 4.74754 7.77217 5.198 7.98433 5.67946C8.19842 6.16529 8.48737 6.62013 8.85329 7.04433C8.94567 7.15083 9.09529 7.29092 9.31342 7.46625C9.54512 7.65254 9.73871 7.81783 9.89167 7.96121C9.97733 8.04154 10.0571 8.12925 10.1179 8.22425C10.177 8.3165 10.2371 8.44525 10.2371 8.59912C10.2371 8.95779 10.0222 9.28946 9.76021 9.57529C9.49617 9.86333 9.19183 10.1362 8.84892 10.3946C8.53287 10.6327 8.16138 10.9341 7.73367 11.3C7.31379 11.6593 6.97675 11.9888 6.71846 12.2884C6.47054 12.5847 6.25729 12.9308 6.0805 13.3296C5.89183 13.7552 5.76679 14.0809 5.69871 14.3132C5.65917 14.448 5.61825 14.5689 5.57475 14.6623C5.554 14.7069 5.52304 14.7665 5.47858 14.8215C5.44996 14.8567 5.32992 15 5.11854 15C4.74067 15 4.33108 14.8239 3.91483 14.562C3.48 14.2884 3.04308 13.9106 2.60296 13.438C2.16433 12.9671 1.75054 12.445 1.36112 11.8723C0.960213 11.2827 0.634929 10.6237 0.383579 9.89754C0.129925 9.16475 0 8.44633 0 7.74425C0 6.88971 0.232171 6.09725 0.693442 5.37587C1.15264 4.65779 1.77754 4.09096 2.55888 3.67617Z"
        />
      </g>
    </IconBase>
  );
};

export default IconLiver;
